import ReactGA from 'react-ga';
import { GA_PAGE_VIEW } from './types';

export const applicationTrackGaPageview = () => (dispatch) => {
  ReactGA.pageview(window.location.href);
  dispatch({ type: GA_PAGE_VIEW });
};
